export const WORKSPACE_LAYOUT = {
  SIDECAR_WIDTH: 380,
  SIDECAR_COLLAPSED_WIDTH: 48,
  SIDECAR_MIN_WIDTH: 280,
  SIDECAR_MAX_WIDTH: 520,
  IDENTITY_BAR_HEIGHT: 64,
  LENS_TAB_HEIGHT: 44,
} as const;

export type LensKey =
  | 'strategy'
  | 'products'
  | 'angles'
  | 'requirements'
  | 'assets'
  | 'performance'
  | 'connected_ads'
  | 'lineage';

// Performance and Ads lead the tab order so that once a brief goes live
// the first thing users see is real spend/ROAS data and the linked creatives.
// For draft briefs the default landing lens is still Strategy (see BriefWorkspace).
export const LENS_ORDER: Array<{ key: LensKey; label: string }> = [
  { key: 'performance', label: 'Performance' },
  { key: 'connected_ads', label: 'Ads' },
  { key: 'strategy', label: 'Strategy' },
  { key: 'products', label: 'Products' },
  { key: 'angles', label: 'Angles' },
  { key: 'requirements', label: 'Requirements' },
  { key: 'assets', label: 'Assets' },
  { key: 'lineage', label: 'Lineage' },
];
